var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBillOfSale = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#69BB10",
  fillRule: "evenodd",
  d: "M5.207 1.333h5.587c2.06 0 3.206 1.187 3.206 3.22v6.887c0 2.066-1.147 3.226-3.206 3.226H5.207C3.18 14.666 2 13.506 2 11.44V4.553c0-2.033 1.18-3.22 3.207-3.22m.18 3.107v-.007h1.992a.522.522 0 0 1 0 1.047H5.387a.52.52 0 0 1 0-1.04m0 4.053h5.226a.52.52 0 0 0 0-1.04H5.387a.52.52 0 0 0 0 1.04m0 3.047h5.226a.52.52 0 0 0 .467-.52c0-.274-.2-.5-.467-.527H5.387a.53.53 0 0 0-.5.807c.106.166.3.266.5.24",
  clipRule: "evenodd"
})));
export default SvgBillOfSale;